module.exports = __webpack_public_path__ + "img/towncenter_tech_Normal_ua.fa3d50af.webp";